import { render, staticRenderFns } from "./v-signup-price.vue?vue&type=template&id=d472d188&scoped=true&"
import script from "./v-signup-price.vue?vue&type=script&lang=js&"
export * from "./v-signup-price.vue?vue&type=script&lang=js&"
import style0 from "./v-signup-price.vue?vue&type=style&index=0&id=d472d188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d472d188",
  null
  
)

export default component.exports